import { observable, action, computed } from 'mobx'
import { persist, create } from 'mobx-persist'
import _ from 'lodash'

//utils
import moment from 'moment'
import RequestsService from 'services/RequestsService';
import CompanyService from 'services/CompanyService'

//stores
import { Operation } from 'modules/adventure/AdventureStore'
import Helpers from 'utils/Helpers';

//models
import Adventure from 'models/Adventure'
import Request from 'models/Request'
import RuleTimeOperation from 'models/RuleTimeOperation';

class ResquestsStore {

  @observable requests = []
  @observable request;
  @observable adventures = []
  @observable adventure = undefined
  operatings = []
  @persist('list') @observable reservesView = []
  @observable schedule = {}
  @observable scheduleOfAdventure = []
  @observable scheduleOfDate = []
  @observable custom_fields = []

  //caledar interaction
  @observable selectedDate = new Date();
  @observable calendarViewMode = 'month'
  @observable requestFeedScrollPosition = 'month'

  //loading flags
  @observable loading = false
  @observable firstLoading = true
  @observable loadingChangeRequest = false
  @observable customFieldsLoading = false
  @observable requestCreationLoading = false
  @observable loadingGetAllAdeventuresByCompany = false
  @observable loadingGetAllOperatingByCompany = false
  @observable changingRequestObsInfo = false
  @observable getAvaiableHoursOfAdventureByDateLoading = false
  @observable loadingCalendar = false
  @observable loadingGetScheduleOfDate = false
  @observable loadingGetAllOperatingsByAdventure = false
  @observable loadingGetRequest = false
  @observable isLoadingVouchers = false
  @observable isLoadingInvalidVouchers = false

  @observable fetchingCompanyTags = false
  @observable companyTags = []

  @observable fetchingRequestTags = false
  @observable requestTags = []

  @observable fetchingReserveTags = false
  @observable reserveTags = []

  @observable savingRequestTags = false

  //pagination requestfeed used in computed
  // @observable confirmedPage = 1
  // @observable urgentPage = 1


  ////////////////////
  //////COMPUTED//////
  ////////////////////
  @computed
  get urgentsRequests() {
    return this.requests.filter(reservation => reservation.isUrgent)
  }

  @computed
  get confirmedRequests() {
    return this.requests.filter(reservation => reservation.isConfirmed)
  }

  @computed
  get confimedRequestsPagination() {
    return this.confirmedRequests.slice(0, this.confirmedPage * 10)
  }

  @computed
  get urgentsRequestsPagination() {
    return this.urgentsRequests.slice(0, this.urgentPage * 10)
  }


  @computed
  get urgentsRequestsThisWeek() {
    return this.requests.filter(reservation => reservation.isUrgent && reservation.isThisWeek && this.requests)
  }

  @computed
  get confirmedRequestsThisWeek() {
    return this.requests.filter(reservation => reservation.isConfirmed && reservation.isThisWeek)
  }

  @computed
  get todayRequests() {
    return this.requests.filter(reservation => Helpers.isSameDate(new Date(), reservation.date) && reservation.isConfirmed);
  }

  ///////////////////
  //////ACTIONS//////
  ///////////////////
  @action
  setRequestFeedScrollPosition(scrollPos) {
    this.requestFeedScrollPosition = scrollPos;
  }

  @action
  setSelectedDate(date) {
    if (this.loadingGetScheduleOfDate) {
      return;
    }
    this.selectedDate = date;
  }

  @action
  setCalendarViewMode(viewMode) {
    this.calendarViewMode = viewMode
  }

  @action
  toggleRequestType(pk_request) {
    return RequestsService.toggleType({ pk_request })
      .then(res => {
        if (res.data) {
          this.request.type = res.data.type;
        }
      }).catch(err => {
        console.error(err);
      })
  }

  @action
  changeRequestObsInfo(data) {
    this.changingRequestObsInfo = true
    return RequestsService.changeRequestObsInfo(data)
      .then(res => {
        const { email, name, observation, phone } = res.data

        const index = this.requests.findIndex(request => request.pk_request === res.data.pk_request)
        if (index !== -1) {
          const request = { ...new Request(this.requests[index]), email, name, observation, phone }
          this.requests.splice(index, 1, new Request(request))
        }
        this.request = new Request({ ...this.request, email, name, observation, phone })

        this.changingRequestObsInfo = false
      })
      .catch(err => this.changingRequestObsInfo = false)
  }

  @action
  setLastSeenForReserves(pk_request) {
    const request = this.requests.find(request => request.pk_request === pk_request);

    if (request) {
      request.reserves
        .map(reserve => reserve.pk_reserve)
        .filter(pk_reserve => {
          return _.findIndex(this.reservesView, reserve =>
            reserve.pk_reserve === pk_reserve
          ) === -1
        })
        .forEach(pk_reserve => {
          this.reservesView.push({
            pk_reserve: pk_reserve,
            lastSeen: moment()
          })
        })
    }

  }

  @action
  setRequestPagination(page) {
    this.confirmedPage = page
  }

  @action
  setUrgentPagination(page) {
    this.urgentPage = page
  }

  @action
  getNextRequests() {
    if (this.firstLoading) {
      this.firstLoading = false
      this.loading = true
    }

    return RequestsService.getNextRequests()
      .then(res => {
        const oldRequests = [...this.requests]
        
        res.data.forEach(request => {
          if (!oldRequests.find(storeRequest => storeRequest.pk_request === request.pk_request)) 
            oldRequests.push(new Request(request))
        })

        this.requests = oldRequests

        this.loading = false
      })
      .catch(error => console.log(error))
  }

  @action
  cancelRequest(pk_request, description) {
    this.firstLoading = true
    return RequestsService.cancelRequest({ pk_request, description })
      .then(res => {
        this.getNextRequests()
        if (!!this.request && this.request.pk_request === res.data.pk_request) this.request = new Request(res.data)
      })
      .catch(err => console.log(err))
  }

  @action
  confirmRequest(pk_request) {
    this.firstLoading = true
    RequestsService.confirmRequest({ pk_request })
      .then(res => {
        this.getNextRequests()
        if (!!this.request && this.request.pk_request === res.data.pk_request) this.request = new Request(res.data)
      })
      .catch(err => console.log(err))
  }

  @action
  confirmChangeMaxOfParticipants(pk_request, max) {
    return RequestsService.confirmChangeMaxOfParticipants({
      pk_request: pk_request,
      max: max
    })
  }

  @action
  createReserve(reserve) {
    if (this.request) {
      return RequestsService.createReserveForRequest(this.request.pk_request, reserve)
    }
  }

  @action
  editReserve(reserve) {
    if (this.request) {
      return RequestsService.updateReserve(reserve)
    }
  }

  @action
  cancelIndividualReserve(pk_reserve) {
    return RequestsService.cancelIndividualReserve({ pk_reserve })
      .then(res => {
        this.requests.forEach(request => {
          const reserveIndex = request.reserves.findIndex(reserve => reserve.pk_reserve === pk_reserve)
          if (reserveIndex !== -1) {
            this.requests[reserveIndex] = new Request(res.data)
          }

        })
      })
      .catch(err => console.log(err))
  }

  @action
  getAllAdventuresByCompany() {
    this.loadingGetAllAdeventuresByCompany = true
    return RequestsService.getAllAdventuresByCompany()
      .then(res => {
        this.loadingGetAllAdeventuresByCompany = false
        return this.adventures = res.data.map(adventure => new Adventure(adventure))
      })
      .catch(err => console.log(err))
  }

  @action
  setAdventure(adventure) {
    this.adventure = adventure;
  }

  @action
  setAdventureVouchers() {
    if (this.adventure) {
      this.isLoadingVouchers = true;
      return RequestsService.getAdventureValidVouchers({pkAdventure: this.adventure.pk_adventure})
      .then(data => {
        if (data) {
          this.adventure.vouchers = data.data;
          this.isLoadingVouchers = false;
        }
      })
    }
  }

  @action
  setAdventureInvalidVouchers() {
    if (this.adventure) {
      this.isLoadingInvalidVouchers = true;
      return RequestsService.getAdventureInvalidValidVouchers({pkAdventure: this.adventure.pk_adventure})
      .then(data => {
        if (data) {
          this.adventure.invalidVouchers = data.data;
          this.isLoadingInvalidVouchers = false;
        }
      })
    }
  }

  @action
  validateVoucher(params) {
    return RequestsService.validateVoucher(params)
    .then(() => this.setAdventureVouchers())
  }

  @action
  cancelVoucher(params) {
    return RequestsService.cancelVoucher(params)
    .then(() => this.setAdventureVouchers())
  }

  @computed
  get adventuresHasOperations() {
    let hasOperating = false

    this.adventures.forEach((a) => {
      if (a.operatings.length > 0) {
        hasOperating = true
      }
    })

    return hasOperating
  }

  @action
  getAllOperatingsByCompany() {
    this.loadingGetAllOperatingByCompany = true
    RequestsService.getAllOperatingsByCompany()
      .then(res => {
        this.loadingGetAllOperatingByCompany = false
        return this.operatings = res.data.map(operating => new Operation(operating))
      }).catch(err => console.log(err))
  }

  @action
  getAvaiableHoursOfMonthByAdventure(pk_adventure, date) {
    const params = {
      month: moment(date).format('MM'),
      year: moment(date).format('YYYY'),
      pkAdventure: pk_adventure,
    }

    this.getAvaiableHoursOfAdventureByDateLoading = true
    return RequestsService.getAvaiableHoursOfMonthByAdventure(params)
      .then(res => {
        const mergeSchedule = {
          ...this.schedule,
          [pk_adventure]: {
            ...this.schedule[pk_adventure],
            ..._.keyBy(res.data, 'date')
          }
        }

        this.schedule = mergeSchedule
        this.getAvaiableHoursOfAdventureByDateLoading = false
      })
      .catch(err => console.log(err))
  }

  @action
  createRequest(data) {
    this.requestCreationLoading = true
    return RequestsService.createRequest(data)
      .then(res => {
        this.requests.push(new Request(res.data))
        this.requestCreationLoading = false
        return res.data
      })
      .catch(err => {
        console.log(err)
        this.requestCreationLoading = false
        throw err
      })
  }

  @action
  doCheckIn(pk_reserve) {
    return RequestsService.doCheckIn(pk_reserve)
      .then(res => {
        this.requests.forEach(request => {
          const reserve = request.reserves.find(reserve => reserve.pk_reserve === pk_reserve)
          if (!!reserve) reserve.checked_in = res.data.checked_in
        })
        this.request && this.request.reserves.forEach(reserve => {
          if (reserve.pk_reserve === res.data.pk_reserve) reserve.checked_in = res.data.checked_in
        })
      })
      .catch(err => console.log(err))
  }

  @action
  sendEmailToUserReserve(pk_reserve, description) {
    const data = {
      pk_reserve, description
    }
    return RequestsService.sendEmailToUserReserve(data)
      .catch(err => console.log(err))
  }

  @action
  sendEmailToWholeRequestUsers(pk_request, description) {
    const data = {
      pk_request, description
    }
    return RequestsService.sendEmailToWholeRequestUsers(data)
      .catch(err => console.log(err))
  }

  @action
  getRequestsByMonth(date) {

    const startDate = `${moment(date || new Date()).format('YYYY-MM')}-01`
    const endDate = `${moment(date || new Date()).format('YYYY-MM')}-31`

    this.loadingCalendar = true
    return RequestsService.getRequestsByMonth(startDate, endDate)
      .then(res => {
        const oldRequests = [...this.requests]

        res.data.forEach(request => {
          if (!oldRequests.find(storeRequest => storeRequest.pk_request === request.pk_request)) 
            oldRequests.push(new Request(request))
        })

        this.requests = oldRequests
        this.loadingCalendar = false
      })
      .catch(err => console.log(err))
  }

  @action
  getScheduleOfDate(date) {
    if (this.loadingGetScheduleOfDate) {
      return;
    }
    this.loadingGetScheduleOfDate = true

    const formattedDate = moment(date).format("YYYY-MM-DD")
    return RequestsService.getScheduleOfDate({ date: formattedDate })
      .then(data => {
        //console.log(res.data);
        this.scheduleOfDate = data.map(schedule => ({
          adventure: new Adventure(schedule.adventure),
          schedule: schedule.schedule.map(hour => ({
            start: hour.start,
            request: hour.request ? new Request(hour.request) : undefined,
            pk_schedule_rule: hour.pk_schedule_rule
          }))
        }))
        //console.log(this.scheduleOfDate);
        this.loadingGetScheduleOfDate = false
      })
      .catch(err => console.log(err))
  }

  @action
  getOperatingsByAdventure(params) {
    this.loadingGetAllOperatingsByAdventure = true
    return RequestsService.getOperatingsByAdventure(params)
      .then(res => {
        this.loadingGetAllOperatingsByAdventure = false
        return this.operatings = res.data.map(operating => new Operation(operating))
      }).catch(err => console.log(err))
  }

  @computed
  get vancancies(){
    const max = this.request.max ? this.request.max : this.request.adventure.max
    return max - this.request.reserves.length
  }

  @action
  getRequest(params) {
    this.loadingGetRequest = true
    return RequestsService.getRequest(params)
      .then(res => {
        this.loadingGetRequest = false
        this.request = new Request(res.data)
        return this.request
      })
      .catch(err => err)
  }

  @action
  getRequestCustomFieldsForAdventure(pkAdventure) {
    this.customFieldsLoading = true
    this.custom_fields = []
    return RequestsService.getRequestCustomFieldsForAdventure(pkAdventure)
      .then(res => {
        this.customFieldsLoading = false
        this.custom_fields = res.data
        return res.data
      })
      .catch(err => {
        console.log(err)
        this.customFieldsLoading = false
      })
  }

  @action
  changeRequest(params) {
    this.requestCreationLoading = true
    return RequestsService.changeRequest(params)
      .then(res => {
        const edditedRequest = new Request(res.data);
        const index = this.requests.findIndex((r) => r.pk_request === edditedRequest.pk_request)
        this.requests.splice(index, 1, edditedRequest)
        this.requestCreationLoading = false
        return res.data
      })
      .catch(err => {
        throw err
      })
  }

  @action
  getCompanyTags() {
    this.fetchingCompanyTags = true
    return CompanyService.getCompanyTags()
      .then(res => {
        this.fetchingCompanyTags = false
        this.companyTags = res.data
      })
      .catch(err => {
        this.fetchingCompanyTags = false
        throw err
      })
  }

  @action
  getRequestTags(params) {
    this.fetchingRequestTags = true

    return RequestsService.getRequestTags(params)
      .then(res => {
        this.fetchingRequestTags = false
        this.requestTags = res.data
      }).catch(err => {
        this.fetchingRequestTags = false
        throw err
      }) 
  }

  @action
  getReserveTags(params) {
    this.fetchingReserveTags = true

    return RequestsService.getReserveTags(params)
      .then(res => {
        this.fetchingReserveTags = false
        this.reserveTags = res.data
      }).catch(err => {
        this.fetchingReserveTags = false
        throw err
      }) 
  }

  @action
  addRequestTag(tag, pkRequest) {
    if(!this.requestTags.find((rt) => rt.fk_company_tag === tag.pk_company_tag)) {
      this.requestTags.push({
        fk_company_tag: tag.pk_company_tag,
        fk_request: Number(pkRequest)
      })
    } else {
      const index = this.requestTags.findIndex((rt) => rt.fk_company_tag === tag.pk_company_tag)
      if(!tag.default){
        this.requestTags.splice(index, 1)
      }
    } 
  }

  @action
  addReserveTag(tag, pkReserve) {
    if(!this.reserveTags.find((rt) => rt.fk_company_tag === tag.pk_company_tag)) {
      this.reserveTags.push({
        fk_company_tag: tag.pk_company_tag,
        fk_reserve: Number(pkReserve)
      })
    } else {
      const index = this.reserveTags.findIndex((rt) => rt.fk_company_tag === tag.pk_company_tag)
      if(!tag.default){
        this.reserveTags.splice(index, 1)
      }
    } 
  }

  @action
  saveRequestTags(pkRequest) {
    this.savingRequestTags = true

    return RequestsService.saveRequestTags({
      requestTags: this.requestTags,
      pkRequest: Number(pkRequest)
    })
      .then(res => {
        this.savingRequestTags = false
      }).catch(err => {
        this.savingRequestTags = false
        throw err
      }) 
  }

  @action
  saveReserveTags(pkReserve) {
    this.savingReserveTags = true

    return RequestsService.saveReserveTags({
      reserveTags: this.reserveTags,
      pkReserve: Number(pkReserve)
    })
      .then(res => {
        this.savingReserveTags = false
      }).catch(err => {
        this.savingReserveTags = false
        throw err
      }) 
  }
}

const hydrate = create({})

export const RequestsStore = new ResquestsStore();
export const rehydrateRequestsStore = hydrate('RequestsStore', RequestsStore).rehydrate



// WEBPACK FOOTER //
// ./src/modules/reservations/RequestsStore.js